import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

export interface PageStatus {
  currentPage: number;
  allItems: number;
  itemsPerPage: number;
}

@Component({
  selector: 'app-small-page-navigator',
  templateUrl: './small-page-navigator.component.html',
  styleUrls: ['./small-page-navigator.component.scss']
})
export class SmallPageNavigatorComponent implements OnInit, OnChanges {
  @Input() pageStatus: PageStatus;
  @Output() currentPageChanged: EventEmitter<number> = new EventEmitter();
  lastPage: number;

  constructor() { }

  ngOnInit(): void {
    // this.setLastPage(this.pageStatus);
  }

  setLastPage(ps: PageStatus) {
    const add = ps.allItems % ps.itemsPerPage === 0 ? 0 : 1;
    this.lastPage = Math.floor(ps.allItems / ps.itemsPerPage) + add;
  }

  goUp() {
    this.setLastPage(this.pageStatus);
    if (this.pageStatus.currentPage < this.lastPage) {
      this.pageStatus.currentPage += 1;
    }
    this.currentPageChanged.emit(this.pageStatus.currentPage);
  }

  goDown() {
    if (this.pageStatus.currentPage > 1) {
      this.pageStatus.currentPage -= 1;
    }
    this.currentPageChanged.emit(this.pageStatus.currentPage);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('pageStatus' in changes) {
      this.setLastPage(changes.pageStatus.currentValue);
    }
  }

}
